// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "8342d42b17603f2993b0" + "-chunk.js";
};